<template>

    <v-dialog v-model="dialogModel" max-width="700">
        <toolbar-page title="PayPal API" icon="mdi-key">
            <template slot="buttons">

                <v-tooltip color="primary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="closeClicked()" v-on="on" icon>
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close this dialog</span>
                </v-tooltip>

            </template>
        </toolbar-page>

        <v-card tile>

            <v-card-text class="pt-3">

                <v-alert class="body-2" type="info" v-show="!active">
                    Please select the environment and enter the API client ID and secret obtained from PayPal.
                </v-alert>

                <v-alert class="body-2" type="success" icon="mdi-alert" v-show="active">
                    PayPal integration is active!
                </v-alert>

                <v-alert class="body-2" type="info" v-show="active">
                    If you need to update client ID or Secret please enter the
                    new values.
                </v-alert>

                <v-select
                    v-model="data.settings.mode"
                    item-text="name"
                    item-value="value"
                    :items="modes"
                    label="Environment"
                ></v-select>

                <v-text-field v-model="data.secrets.client_id"
                              :placeholder="active ? 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' : 'Please enter client ID'"
                              label="Client ID"/>

                <v-text-field v-model="data.secrets.secret"
                              :placeholder="active ? 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' : 'Please enter API key'"
                              label="Secret"/>

                <v-btn color="primary" :disabled="!valuesEntered" :loading="saving" @click="saveClicked" v-if="!active">Save</v-btn>
                <v-btn color="primary" :disabled="!valuesEntered" :loading="saving" @click="saveClicked" v-if="active">Update</v-btn>

                <json v-if="false" :data="partner"/>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import Json from 'vue-json-pretty';
import ToolbarPage from "../../../../components/UI/ToolbarPage";
import {mapActions} from 'vuex';

const vuexModule = 'Rewards';

const defaults = {
    id: null,
    enabled: true,
    type: 'PayPal',
    settings: {
        mode: 'sandbox'
    },
    secrets: {
        client_id: null,
        secret: null,
    }
}

export default {

    components: {
        Json,
        ToolbarPage
    },

    props: {
        value: {
            required: true,
            type: Boolean,
        },
        active: {
            required: true,
            type: Boolean
        },
        partner: {
            required: false,
            type: Object,
            default: () => {
                return defaults;
            }
        }
    },

    data() {
        return {
            minPermission: 'view rewards',
            saving: false,
            data: defaults,
            modes: [
                {name: 'Sandbox (testing)', value: 'sandbox'},
                {name: 'Live (production)', value: "production"}
            ]
        }
    },
    computed: {

        dialogModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },

        valuesEntered() {
            if (!this.data.secrets) return false;
            return this.data.secrets.client_id !== null && this.data.secrets.secret !== null;
        }
    },

    mounted() {
        this.data = Object.assign({}, this.partner);
    },

    methods: {
        ...mapActions(vuexModule, [
            'createPartnerSettings',
        ]),

        saveClicked() {

            this.saving = true;

            this.createPartnerSettings(this.data)
                .then(() => {
                    this.closeClicked();
                })
                .catch(error => {

                    if (error.response.status === 422) {
                        Bus.$emit('flash-message', {type: 'error', message: error.response.data.message});
                        return;
                    }

                    Bus.$emit('flash-message', {type: 'error', message: error.response.data.message});
                })
                .finally(() => {
                    this.saving = false;
                })
        },

        closeClicked() {
            this.$emit('input', false);
        },
    },
}

</script>
